import axios from "axios";
import {API_URL} from "../../config/api.config";

export const QR_PURCHASE = "/api/qr-purchase";

// Newest-first list of QrScanEvent
export function getQrScanEvents(limit = 200) {
    return axios.get(API_URL + QR_PURCHASE + "/events", {params: {limit}});
}

// { enabled, busyWeighbridges, recentWindowMinutes }
export function getQrPurchaseStatus() {
    return axios.get(API_URL + QR_PURCHASE + "/status");
}
